<template>
	<el-dialog
		append-to-body
		id="quick-config-children-dialog"
		class="custom-dialog todo-quick-config-children-dialog"
		:visible.sync="isDialogActiveLocal"
		:before-close="handleBeforeCloseDialog"
	>
		<template #title>
			<div class="flex flex-wrap">
				<h4 class="uppercase font-bold block text-xl w-full">Thêm chi tiết</h4>
				<p class="text-base text-black font-medium">{{ localValue.name }}</p>
			</div>
		</template>
		<PerfectScrollbar>
			<cbs-quick-config-children-todo
				class="form todo-quick-config-children-dialog__form p-3 sm:p-6"
				v-model="localChildrenValue"
				:parentId="localValue.id"
				:todoType="$constant.TODO_TYPE.NORMAL"
				@onClickAddTodoItem="$emit('onClickAddTodoItem')"
				@onClickRemoveTodoItem="removeIndex => $emit('onClickRemoveTodoItem', removeIndex)"
			/>
		</PerfectScrollbar>

		<div
			slot="footer"
			class="flex items-center sm:px-12 justify-center"
		>
			<vs-button
				@click.stop="submitData"
				class="w-full sm:w-2/5 font-bold"
			>{{ $t('Actions.Save') }}</vs-button>
		</div>
	</el-dialog>
</template>

<script>
import { cloneDeep as lodashCloneDeep } from "lodash";

import CbsQuickConfigChildrenTodo from "@/components/cbs-quick-config-children-todo/CbsQuickConfigChildrenTodo";

export default {
	name: "TodoQuickConfigChildrenDialog",
	components: { CbsQuickConfigChildrenTodo },
	provide() {
		return { parentValidator: this.$validator };
	},
	props: {
		value: {
			type: Object,
			required: true
		},
		isDialogActive: {
			type: Boolean,
			required: true
		},
		isEditable: {
			type: Boolean,
			default: false
		}
	},
	emits: {
		closeDialog: {
			required: true
		},
		onSubmit: {
			required: true
		},
		onClickAddTodoItem: {
			required: true
		},
		onClickRemoveTodoItem: {
			required: true
		}
	},
	data() {
		return {
			initFormData: {},
			isFormDirty: false
		};
	},
	computed: {
        localValue: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		},
		localChildrenValue: {
			get() {
				return this.localValue.children || [];
			},
			set(val) {
				this.localValue.children = [...val];
			}
		},
		isDialogActiveLocal: {
			get() {
				return this.isDialogActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeDialog");
				}
			}
		}
	},
	watch: {
		isDialogActive(val) {
			if (!val) return;

			if (!this.value) {
				this.initValues();
			}
		},
		localValue: {
			handler: function() {
				this.isFormDirty = JSON.stringify(this.initFormData) !== JSON.stringify(this.localValue);
			},
			deep: true
		}
	},
	methods: {
		initValues() {
			this.isFormDirty = false;
		},
		submitData() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.$emit("onSubmit");
				}
			});
		},
		handleBeforeCloseDialog(setDialogHide) {
			this.handleCloseDialog(() => {
				this.initValues();
				setDialogHide();
			}, this.isFormDirty);
		},
		setDialogBodyHeight(dialogSelector) {
			this.$nextTick(() => {
				const dialogHeader = document.querySelector(`${dialogSelector} .el-dialog__header`);
				const dialogBody = document.querySelector(`${dialogSelector} .el-dialog__body`);
				const dialogFooter = document.querySelector(`${dialogSelector} .el-dialog__footer`);

				if (dialogHeader && dialogBody && dialogFooter) {
					dialogBody.style.height = `calc(100vh - ${dialogHeader.offsetHeight}px - ${dialogFooter.offsetHeight}px)`;
				}
			});
		}
	},
	created() {
		this.initFormData = lodashCloneDeep(this.value);
	},
	mounted() {
		this.setDialogBodyHeight("#quick-config-children-dialog");
	}
};
</script>